export default __webpack_public_path__ + "static/media/footer-map-marker.145962a1.svg";